import React, { createContext } from 'react';

const StorageContext = createContext({
  state: {},
  save: () => {},
  reset: () => {},
  errors: [],
  isEqual: () => false,
});

export const StorageProvider = ({
  children,
  state,
  errors = [],
  onSave,
  onReset,
  isEqual = () => false,
}) => (
  <StorageContext.Provider
    value={{
      state: state,
      save: onSave,
      reset: onReset,
      errors,
      isEqual,
    }}
  >
    {children}
  </StorageContext.Provider>
);

export default StorageContext;
